var Backbone = require('backbone');


var RelationModel = Backbone.Model.extend({
    urlRoot: '/api/relation',

    initialize: function(){
        this.bind("change", this.attributesChanged);
    },

    attributesChanged: function(){
        var valid = false;
        if (this.get('parentId') && this.get('child'))
            valid = true;
        this.trigger("validated", valid);
    }
});


module.exports = RelationModel;


//////////////////
// WEBPACK FOOTER
// ./app/models/relation-model.js
// module id = 230
// module chunks = 0